import React from 'react';
import Portal from '../../Portal';
import Table from '../../Table/Table';

const UserListModal = ({ isOpen, onClose, users, month, year }) => {
  if (!isOpen) return null;

  return (
    <Portal>
      <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex items-center justify-center p-4">
        <div className="bg-white rounded-lg max-w-5xl w-full max-h-[90vh] overflow-hidden shadow-2xl">
        <div className="flex justify-between items-center p-6 border-b bg-gray-50">
          <h2 className="text-xl font-semibold text-gray-900">
            Users - {month} {year} ({users.length} users)
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 p-1 rounded-full hover:bg-gray-200"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <div className="overflow-y-auto" style={{ maxHeight: 'calc(90vh - 80px)' }}>
          {users.length > 0 ? (
            <div className="p-6">
              <div className="overflow-x-auto">
                <Table
                  header={[
                    "Name",
                    "Phone",
                    "Email", 
                    "Location",
                    "Join Date"
                  ]}
                >
                  {users.map((user, index) => (
                    <tr
                      key={user.id || index}
                      className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
                    >
                      <td className="py-2 px-4 text-xs sm:text-sm text-gray-800 border-t">
                        {user.full_name || 'N/A'}
                      </td>
                      <td className="py-2 px-4 text-xs sm:text-sm text-gray-800 border-t">
                        {user.phone || 'N/A'}
                      </td>
                      <td className="py-2 px-4 text-xs sm:text-sm text-gray-800 border-t">
                        {user.email || 'N/A'}
                      </td>
                      <td className="py-2 px-4 text-xs sm:text-sm text-gray-800 border-t capitalize">
                        {user.location || 'N/A'}
                      </td>
                      <td className="py-2 px-4 text-xs sm:text-sm text-gray-800 border-t">
                        {user.createdAt ? 
                          new Date(user.createdAt).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "long", 
                            day: "numeric",
                          }) : 'N/A'
                        }
                      </td>
                    </tr>
                  ))}
                </Table>
              </div>
            </div>
          ) : (
            <div className="text-center py-12 text-gray-500">
              No users found for this month
            </div>
          )}
        </div>
      </div>
      </div>
    </Portal>
  );
};

export default UserListModal;